import { render, staticRenderFns } from "./hospital-profile-documents.vue?vue&type=template&id=12bad4f4&scoped=true"
import script from "./hospital-profile-documents.vue?vue&type=script&lang=ts"
export * from "./hospital-profile-documents.vue?vue&type=script&lang=ts"
import style0 from "./hospital-profile-documents.vue?vue&type=style&index=0&id=12bad4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bad4f4",
  null
  
)

export default component.exports